import getScenarioStore from './getScenarioStore';
import { CalendarEvent } from 'owa-calendar-types';
import { OwaDate } from 'owa-datetime';

export function getSelectedDate(scenario: string): OwaDate | null {
    const { selectedDate } = getScenarioStore(scenario);
    if (!selectedDate) {
        return null;
    }
    return selectedDate;
}

export function shouldGrayOutItem(highlightedEventId: string, event: CalendarEvent): boolean {
    if (!highlightedEventId) {
        return false;
    }

    return (
        event.ItemId.Id != highlightedEventId &&
        (!event.SeriesMasterItemId || event.SeriesMasterItemId.Id != highlightedEventId)
    );
}
